<template>
  <div id="main-container" class="main-container app-theme-white fixed-header vh-100">
    <router-view />
  </div>
  <div id="modal-container">
    <component v-for="(object, index) in modal.data" :key="index" v-show="index + 1 == modal.data.length" :is="object.modal" :config="object.data" @close="closeModal" @closeAll="closeAllModal" />
  </div>
  <component v-show="subModalView()" class="sub-modal" :is="subModalView()" :config="configSubModal()" @close="closeSubModal" />
</template>
<script>
export default {
  components: {},
  data() {
    return {
      modal: {
        storeId: 'modal',
        data: []
      },
      subModal: {
        storeId: 'modal',
        view: false,
        data: {},
        callback: null,
        timeHandle: null
      },
      filterNotification: {
        page: 1,
        type: ''
      }
    }
  },
  mounted() {
    this.$emitter.on('Modal', this.initModal)
    this.$emitter.on('SubModal', this.initSubModal)
    this.$emitter.on(`notifications.readAll`, this.readAllNotification)
    this.$emitter.on(`notifications.filter`, this.getNotification)
    window.addEventListener('load', this.onload)
    window.addEventListener('resize', this.onload)
    window.addEventListener('beforeunload', this.unload)
    setTimeout(() => {
      this.getNotification()
    }, 5000)
  },
  unmounted() {
    this.$emitter.off('Modal', this.initModal)
    this.$emitter.off('SubModal', this.initSubModal)
    this.$emitter.off(`notifications.readAll`, this.readAllNotification)
    this.$emitter.off(`notifications.filter`, this.getNotification)
    window.removeEventListener('load', this.onload)
    window.removeEventListener('resize', this.onload)
    window.removeEventListener('beforeunload', this.unload)
    if (this.timeHandle) {
      clearInterval(this.timeHandle)
      this.timeHandle = null
    }
  },
  methods: {
    onload() {
      let $el = document.querySelector('#main-container')
      if (window.innerWidth > 1199) {
        if ($el.classList.contains('closed-sidebar-mobile')) {
          $el.classList.remove('closed-sidebar-mobile', 'closed-sidebar')
        }
      } else {
        if (!$el.classList.contains('closed-sidebar-mobile')) {
          $el.classList.add('closed-sidebar-mobile', 'closed-sidebar')
        }
      }
    },
    unload(e) {
      if (window.uploading > 0) {
        const message = 'Some processes are not completed. Do you want to continue?'
        e.preventDefault()
        e.returnValue = message
        return message
      }
    },
    async getNotification(filter) {
      this.filterNotification = Object.assign({}, this.filterNotification, filter || {})
      let response = await this.$util.get(`notifications`, this.filterNotification, document.querySelector('.notification .list-notification'), {}, {}, { force: true })
      if (response && response.status == 'success') {
        this.$store.commit('SET_DATA', {
          keys: ['notifications'],
          value: response
        })
      }
    },
    async readAllNotification() {
      let latest = 0
      let data = this.$store.getters.data?.notifications?.data || {}
      Object.entries(data).forEach(([, item]) => {
        if (item.date_created && latest < item.date_created) {
          latest = item.date_created
        }
      })

      let response = await this.$util.forcePost(`notifications`, {
        latest
      })
      if (response.status == 'success') {
        this.$store.commit('SET_DATA', {
          keys: ['notifications', 'unread'],
          value: 0
        })
      }
    },
    initModal(e) {
      let object = {
        $el: e.$el || null,
        modal: e.name || '',
        data: e || {}
      }
      let names = (e.name || '').split('.')
      let path = `/(views|components)/*.*/${names.shift() || ''}/Modal/${names.join('/') || ''}.vue`
      if (object.modal && this.$options.components[object.modal] == undefined) {
        this.$options.components[object.modal] = this.$util.requireOrNull(path)
      }

      if (this.$options.components[object.modal] !== null) {
        this.$emitter.emit('Modal.View', {
          modal: object.modal
        })

        delete object.data.name
        if (_.isEmpty(object.data.storeId)) {
          object.data.storeId = [this.modal.storeId, object.modal.replace('.', '-')]
        }

        this.modal.data.push(object)
      } else {
        alert(
          `Modal [${(e.name || '')
            .split(/\/|\.|-/)
            .map(_.pascalCase)
            .join(' ')}] not supported`
        )
      }
    },
    closeModal() {
      let modal = this.modal.data.pop()
      this.$emitter.emit('Modal.Close', {
        modal: modal.modal
      })
    },
    closeAllModal() {
      this.modal.data = []
      this.$emitter.emit('Modal.CloseAll', {
        modal: null
      })
    },
    initSubModal(e) {
      this.subModal.view = _.pascalCase(e.name) || ''
      this.subModal.data = e.data || {}
      this.subModal.callback = e.callback || null
    },
    subModalView() {
      let action = this.subModal.view
      let modal = `SubModal.${action}`
      if (!this.$options.components?.[modal]) {
        this.$options.components[modal] = this.$util.requireOrNull(`components/Modal/${action}.vue`)
      }

      if (this.$options.components[modal] !== null) {
        return modal
      } else {
        return null
      }
    },
    closeSubModal() {
      this.subModal.view = false
    },
    configSubModal() {
      return {
        storeId: [this.subModal.storeId, this.subModalView],
        data: this.subModal.data,
        callback: this.subModal.callback
      }
    }
  }
}
</script>
<style lang="scss">
@use 'sass:color';
@use '../assets/css/app.css';
@use '../assets/scss/tabler-icons.scss';
@use '../assets/scss/main.scss';
@use '../assets/scss/style.scss';
@use 'tippy.js/dist/tippy.css';
@use 'vue-toast-notification/dist/theme-sugar.css';

$pri-color: #00c700;
$white-color: #f4f4f4;
:root {
  --border-radius: 20px;
}
body {
  background: #f5f5f9;
  word-break: break-word;
  &:not(.loaded) {
    .app-sidebar,
    .app-page-title {
      display: none;
    }
    .app-main__outer {
      padding-left: 0;
    }
  }
}
.main-container {
  display: flex;
  overflow-y: hidden;
}
.sub-modal {
  z-index: 9999 !important;
}

.lazy-error {
  background: url(@/../assets/imgs/no-preview.jpg) no-repeat;
  background-position: center;
  background-size: auto;
  img {
    display: none;
  }
}

.scrollbar {
  overflow: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: #e9e9e9;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bcc8ca;
    border-radius: 5px;
    border: 0;
    background-clip: content-box;
    &:hover {
      background-color: #929b9c;
    }
  }
}

.dp__input {
  border-radius: var(--border-radius, 0.25rem) !important;
}
div.multiselect {
  border-radius: 0 !important;
  border: 0 !important;
  box-shadow: 0 0 0 !important;
  background: transparent !important;
  min-height: 38px !important;
  margin: 0;
  .multiselect-wrapper {
    background: #fff;
    overflow: hidden;
    border-radius: var(--border-radius, 0.25rem) !important;
    border: var(--ms-border-width, 1px) solid var(--ms-border-color, #d1d5db);
  }
  .multiselect-dropdown {
    overflow: auto;
    border-radius: var(--border-radius, 0.25rem) !important;
    @extend .scrollbar;
    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border: 5px solid transparent;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
  .multiselect-search {
    background: transparent;
  }
  .select {
    margin: 0;
    min-height: auto;
    .multiselect-wrapper {
      min-height: 38px;
    }
    .multiselect-tag {
      white-space: break-spaces;
    }
  }
}

.lazy-loading:not(.lazy-loaded):not(.lazy-error) {
  position: relative;
  &::after {
    animation: tool-spin 0.7s linear infinite;
    width: 22px;
    height: 22px;
    border: 2px solid rgb(55 203 61);
    border-left-color: transparent;
    display: block;
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    visibility: visible;
    border-radius: 50%;
    z-index: 9999;
    background: transparent !important;
  }

  &.thumbnail {
    &::after {
      width: 16px;
      height: 16px;
    }
  }
}

.read-only {
  input,
  select,
  textarea {
    pointer-events: none;
    opacity: 0.8;
  }

  .input-group-append {
    display: none;
  }
}
.text-danger {
  a,
  a:hover {
    color: inherit !important;
  }
}

.card {
  box-shadow: 0 0 0 !important;
  transition: none !important;
  border-radius: var(--border-radius, 0.25rem);
}

@keyframes tool-spin {
  0% {
    animation-timing-function: cubic-bezier(0.5856, 0.0703, 0.4143, 0.9297);
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.break-normal {
  word-break: normal !important;
}
.vue-notification-group {
  top: 5% !important;
}
.img.lazy-error {
  display: flex;
  align-items: center;
  justify-content: center;
}
.radio-container,
.checkbox-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0;
  &:hover input ~ .checkmark {
    opacity: 0.9;
  }
  .checkmark {
    position: relative;
    top: 0;
    left: 0;
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
  }
  input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 9;
    &:checked ~ .checkmark {
      &:after {
        display: block !important;
      }
    }
  }
}

.radio-default-container,
.checkbox-default-container {
  margin-right: 10px;
  display: inline-block;
  position: relative;
  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    + .label {
      &:before {
        content: '';
        background: $white-color;
        border-radius: 100%;
        border: 1px solid color.scale($white-color, $lightness: -25%);
        display: inline-block;
        width: 22px;
        height: 22px;
        position: relative;
        margin-right: 5px;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .label {
        &:before {
          background-color: $pri-color;
          box-shadow: inset 0 0 0 4px $white-color;
        }
      }
    }
    &:focus {
      + .label {
        &:before {
          outline: none;
          border-color: $pri-color;
        }
      }
    }
    &:disabled {
      + .label {
        &:before {
          box-shadow: inset 0 0 0 4px $white-color;
          border-color: color.scale($white-color, $lightness: -25%);
          background: color.scale($white-color, $lightness: -25%);
        }
      }
    }
    + .label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}

.boder-dashed {
  border: 1px dashed #ccc;
  border-radius: var(--border-radius, 0.25rem);
}
.price {
  text-transform: uppercase;
}
.icon {
  display: block;
  margin: 0;
  padding: 0;
}
.icon-attachment {
  background: url('@/../assets/imgs/attachment.svg') no-repeat center;
  width: 50px;
  height: 50px;
}
.icon-send {
  background: url('@/../assets/imgs/send.svg') no-repeat center;
  width: 50px;
  height: 50px;
}

@keyframes ldio-47nff0uv8vv {
  0% {
    transform: translate(6px, 40px) scale(0);
  }
  25% {
    transform: translate(6px, 40px) scale(0);
  }
  50% {
    transform: translate(6px, 40px) scale(1);
  }
  75% {
    transform: translate(40px, 40px) scale(1);
  }
  100% {
    transform: translate(74px, 40px) scale(1);
  }
}
@keyframes ldio-47nff0uv8vv-r {
  0% {
    transform: translate(74px, 40px) scale(1);
  }
  100% {
    transform: translate(74px, 40px) scale(0);
  }
}
@keyframes ldio-47nff0uv8vv-c {
  0% {
    background: $pri-color;
  }
  25% {
    background: $pri-color;
  }
  50% {
    background: $pri-color;
  }
  75% {
    background: $pri-color;
  }
  100% {
    background: $pri-color;
  }
}

.loadingio-spinner-ellipsis {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 68px;
  height: 68px;
  display: inline-block;
  overflow: hidden;
  background: 0;
  .ldio {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(0.68);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
    div {
      position: absolute;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      transform: translate(40px, 40px) scale(1);
      background: $pri-color;
      animation: ldio-47nff0uv8vv 2.941176470588235s infinite cubic-bezier(0, 0.5, 0.5, 1);
      box-sizing: content-box;
      &:nth-child(1) {
        background: $pri-color;
        transform: translate(74px, 40px) scale(1);
        animation:
          ldio-47nff0uv8vv-r 0.7352941176470588s infinite cubic-bezier(0, 0.5, 0.5, 1),
          ldio-47nff0uv8vv-c 2.941176470588235s infinite step-start;
      }
      &:nth-child(2) {
        animation-delay: -0.7352941176470588s;
        background: $pri-color;
      }
      &:nth-child(3) {
        animation-delay: -1.4705882352941175s;
        background: $pri-color;
      }
      &:nth-child(4) {
        animation-delay: -2.205882352941176s;
        background: $pri-color;
      }
      &:nth-child(5) {
        animation-delay: -2.941176470588235s;
        background: $pri-color;
      }
    }
  }
}
</style>
